import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Map } from 'immutable';
import * as cn from 'classnames';
import { ReactComponent as CloseIcon } from 'images/icons-regular-icons-ic-close.svg';
import styles from 'modules/Notifications/components/NotificationItem/NotificationItem.module.scss';

class NotificationItem extends Component {
  isNew() {
    const { item } = this.props;
    return !item.get('readingDate');
  }

  isWarning() {
    const { item } = this.props;
    return item.get('isImportant');
  }

  getClassNames() {
    return cn([
      styles.notification,
      {
        [styles.new]: this.isNew(),
        [styles.warning]: this.isWarning(),
        [styles.info]: this.isNew() && !this.isWarning(),
      },
    ]);
  }

  onClick = () => {
    const { onRead, item, onClick } = this.props;
    if (this.isNew()) {
      onRead(item.get('id'), item.get('notificationId'), item.get('eventTypeId'));
    }

    onClick(item);
  };

  onRemove = (e) => {
    const { onRemove, item } = this.props;
    e.stopPropagation();
    onRemove(item.get('id'), item.get('notificationId'), item.get('eventTypeId'));
  };

  render() {
    const { item, forbidRemoval } = this.props;
    const date = item.get('creationDate');

    return (
      <div className={this.getClassNames()} onClick={this.onClick}>
        <div className={styles.dateTime}>
          {moment(date).format('DD.MM.YYYY')} &bull; {moment(date).format('HH:mm')}
        </div>
        <div className={styles.title}>{item.get('subject')}</div>
        <div className={styles.content}>
          {!item.get('isTextMessage') ? item.get('text') : 'Подробнее'}
        </div>
        {!forbidRemoval && <CloseIcon className={styles.closeBtn} onClick={this.onRemove} />}
      </div>
    );
  }
}

NotificationItem.propTypes = {
  item: PropTypes.instanceOf(Map),
  forbidRemoval: PropTypes.bool,
  onRead: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NotificationItem;
